import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bitcoin } from 'lucide-react';

import { cn } from '@/lib/utils';
import { siteConfig } from '@/config/site';
import { LoginArea } from '@/components/auth/LoginArea';
import { ThemeToggle } from '@/components/ThemeToggle';

const NAV_ITEMS = [
  { label: 'about', id: 'about' },
  { label: 'work', id: 'work' },
  { label: 'notes', id: 'notes' },
] as const;

export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={cn(
        'sticky top-0 z-50 w-full transition-colors duration-300',
        scrolled ? 'border-b bg-background/85 backdrop-blur-md' : 'border-b border-transparent',
      )}
    >
      <div className="container flex h-16 items-center justify-between gap-4">
        <Link to="/" className="group flex shrink-0 items-center gap-2.5">
          <span className="flex size-8 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-amber-500 text-primary-foreground shadow-md shadow-primary/25 transition-transform duration-300 group-hover:rotate-6">
            <Bitcoin className="size-5" />
          </span>
          <span className="font-mono text-base font-bold tracking-tight">
            {siteConfig.handle}
            <span className="animate-pulse text-primary">_</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Sections">
          {NAV_ITEMS.map(({ label, id }) => (
            <a
              key={id}
              href={isHome ? `#${id}` : `/#${id}`}
              className="font-mono text-sm text-muted-foreground transition-colors hover:text-primary"
            >
              <span className="text-primary/50">~/</span>
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-1">
          <ThemeToggle />
          <LoginArea className="max-w-36" />
        </div>
      </div>
    </header>
  );
}
